<template>
  <a-card :bordered="false">
    <a-row :gutter="[16,32]">
      <a-col :span="16" :offset="4" style='text-align: center'>
        <h2>参与计算的评标价</h2>
      </a-col>
    </a-row>
    <a-row :gutter="[16,32]">
      <a-form-model-item :label-col="{span: 4, offset: 4}" :wrapper-col="{span: 12}" label="参与计算的评标价：">
        <a-table
          ref='table'
          size='middle'
          bordered
          rowKey='bidderId'
          :columns='columns'
          :dataSource='benchmarkPriceList'
          class='j-table-force-nowrap'
          >
        <!--<span slot='action' slot-scope='text, record'>
          <a @click='handleEdit(record)' style='margin-left: 5px'>修改</a>
        </span>-->
        </a-table>
      </a-form-model-item>
    </a-row>
    <a-row :gutter="[16,32]" v-if="isShow90TO95">
      <a-form-model-item :label-col="{span: 4, offset: 4}" :wrapper-col="{span: 12}" label="评标价大于等于评标最高限价95%：">
        <a-table
          ref='table'
          size='middle'
          bordered
          rowKey='bidderId'
          :columns='columns'
          :dataSource='benchmarkPrice95List'
          class='j-table-force-nowrap'
        >
          <!--<span slot='action' slot-scope='text, record'>
            <a @click='handleEdit(record)' style='margin-left: 5px'>修改</a>
          </span>-->
        </a-table>
      </a-form-model-item>
    </a-row>
    <a-row :gutter="[16,32]" v-if="isShow90TO95">
      <a-form-model-item :label-col="{span: 4, offset: 4}" :wrapper-col="{span: 12}" label="评标价介于评标最高限价95%~90%：">
        <a-table
          ref='table'
          size='middle'
          bordered
          rowKey='bidderId'
          :columns='columns'
          :dataSource='benchmarkPrice90To95List'
          class='j-table-force-nowrap'
        >
          <!--<span slot='action' slot-scope='text, record'>
            <a @click='handleEdit(record)' style='margin-left: 5px'>修改</a>
          </span>-->
        </a-table>
      </a-form-model-item>
    </a-row>
    <a-row :gutter="[16,32]" v-if="isShow90TO95">
      <a-form-model-item :label-col="{span: 4, offset: 4}" :wrapper-col="{span: 12}" label="评标价小于等于评标最高限价90%：">
        <a-table
          ref='table'
          size='middle'
          bordered
          rowKey='bidderId'
          :columns='columns'
          :dataSource='benchmarkPrice90List'
          class='j-table-force-nowrap'
        >
          <!--<span slot='action' slot-scope='text, record'>
            <a @click='handleEdit(record)' style='margin-left: 5px'>修改</a>
          </span>-->
        </a-table>
      </a-form-model-item>
    </a-row>
    <a-row :gutter="[16,32]">
      <a-form-model-item :label-col="{span: 4, offset: 4}" :wrapper-col="{span: 12}" label="不参与计算的评标价：">
        <a-table
          ref='table'
          size='middle'
          bordered
          rowKey='bidderId'
          :columns='columns'
          :dataSource='notBenchmarkPriceList'
          class='j-table-force-nowrap'
          >
          <!--<span slot='action' slot-scope='text, record'>
            <a @click='handleEdit(record)' style='margin-left: 5px'>修改</a>
          </span>-->
        </a-table>
      </a-form-model-item>
    </a-row>
    <a-row :gutter="[16,32]">
      <a-form-model-item :label-col="{span: 4, offset: 4}" :wrapper-col="{span: 12}" label="否决投标企业列表：">
        <a-table
          ref='table'
          size='middle'
          bordered
          rowKey='bidderId'
          :columns='columns'
          :dataSource='disuseBenchmarkPriceList'
          class='j-table-force-nowrap'
        >
          <!--<span slot='action' slot-scope='text, record'>
            <a @click='handleEdit(record)' style='margin-left: 5px'>修改</a>
          </span>-->
        </a-table>
      </a-form-model-item>
    </a-row>
    <a-row :gutter="[16,32]">
      <a-col :span="16" :offset="4" style='text-align: center'>
        <a-button type="primary" style="margin-right: 10px" @click="prevStep">上一步</a-button>
        <a-button type="primary" style="margin-right: 10px" @click="nextStep">下一步</a-button>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { postAction,getAction } from '@api/manage'
import ARow from 'ant-design-vue/es/grid/Row'
export default {
  name: 'WaterTransportBenchmarkPriceComputeStep2',
  components: { ARow },
  data() {
    return {
      //交通施工低价有效评标价大于等于15家显示控制
      isShow90TO95:false,
      isCheck: true,
      //投标人有效评标价
      benchmarkPriceList:[],
      //所有评标价大于等于评标最高限价95%的投标人的评标价
      benchmarkPrice95List:[],
      //所有评标价小于评标最高限价的95%且大于评标最高限价的90%的投标人的评标价
      benchmarkPrice90To95List:[],
      //所有评标价小于等于评标最高限价的90%的投标人的评标价
      benchmarkPrice90List:[],
      //投标人无效评标价
      notBenchmarkPriceList:[],
      //废标企业列表
      disuseBenchmarkPriceList:[],
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '球号',
          align: 'center',
          dataIndex: 'bidderBall'
        },
        {
          title: '投标人名称',
          align: 'center',
          dataIndex: 'bidderName'
        },
        {
          title: '企业信用等级',
          align: 'center',
          dataIndex: 'enterpriseCreditGrade',
          customRender: function(t, r, index) {
            if(t==null)
            {
              return '/'
            }
            return t;
          }
        },
        {
          title: '投标报价金额（元）',
          align: 'center',
          dataIndex: 'bidPrice'
        },
        {
          title: '评标价(元)',
          align: 'center',
          dataIndex: 'evaluationPrice'
        },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
    }
  },
  props: ['sectionId','bidProjectId','workflowInstanceId','instStepId'],
  created() {
    this.setButtonStatus();
    this.getBenchmarkResult();
  },
  methods: {
    setButtonStatus(){
      let that = this
      getAction('/ebid-ce/boOpenStatus/getBoOpenStatus', {
        sectionId: that.sectionId,
      }).then((res) => {
        if (res.success) {
          if(res.result.isKstandPriceFinish==1){
            that.isCheck = true;
          }else {
            that.isCheck = false;
          }
        }
      })
    },
    handleEdit(record){
      alert(record.evaluationPrice);
    },
    getBenchmarkResult() {
      getAction('/ebid-ce/waterTransportBenchmarkPriceCompute/getValidBenchmarkPrice/' + this.bidProjectId + "/" + this.sectionId+"/"+this.workflowInstanceId+"/"+this.instStepId, {}).then((res) => {
        if (res.success) {
          this.benchmarkPriceList = res.result.benchmarkPriceList;
          this.benchmarkPrice95List = res.result.benchmarkPrice95List;
          this.benchmarkPrice90To95List = res.result.benchmarkPrice90To95List;
          this.benchmarkPrice90List = res.result.benchmarkPrice90List;
          this.notBenchmarkPriceList = res.result.notBenchmarkPriceList;
          this.disuseBenchmarkPriceList = res.result.disuseBenchmarkPriceList;
          if(res.result.benchmarkPrice90To95List != null ||  res.result.benchmarkPrice90List != null || res.result.benchmarkPrice95List != null){
            this.isShow90TO95 = true;
          }
        }else {
          this.$message.warning(res.message)
        }
      })
    },
    okHandel() {
      let that = this;
      this.isCheck = true;
      postAction("/ebid-ce/boOpenStatus/checkKstandPrice/" + that.sectionId,{}).then(res=> {
        if (res.success) {
          that.$message.success(res.result)
        } else {
          this.isCheck = false;
          that.$message.error(res.message)
        }
      }).catch(error => {
        this.isCheck = false;
        that.$message.error(error)
      })
    },
    prevStep () {
      this.$emit('prevStep')
    },
    nextStep () {
      this.$emit('nextStep')
    }
  }
}
</script>

<style scoped>

</style>